export default __webpack_public_path__ + "static/media/diamond.1cd79469.svg";